import React from 'react';
import { Link } from 'react-router';

const FunnelMenu = () => (
  <div className="ui pointing secondary menu">
    <Link to="questions" className="item" activeClassName="active">
      Questions
    </Link>
    <Link to="products" className="item" activeClassName="active">
      Produits
    </Link>
    <Link to="scoring" className="item" activeClassName="active">
      Score
    </Link>
    <Link to="advices" className="item" activeClassName="active">
      Conseils
    </Link>
  </div>
);

export default FunnelMenu;



// WEBPACK FOOTER //
// ./src/modules/funnel/components/FunnelMenu.js